import { useEffect, useState } from "react";
import { Mail, MessageCircle } from "lucide-react";
import { AGENCY } from "@/lib/data";

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#0A0A0A]/80 backdrop-blur-xl border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <div className="px-6 md:px-12 lg:px-20 h-20 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="logo-link"
                    className="flex items-center gap-2"
                >
                    <span className="w-2 h-2 bg-[#FF2A2A] rounded-full" />
                    <span className="font-display text-[15px] tracking-[0.2em] uppercase">
                        {AGENCY.name}
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-10 text-sm text-white/70">
                    <a
                        href="#reel"
                        data-testid="nav-reel"
                        className="hover:text-white transition-colors"
                    >
                        Portafolio
                    </a>
                    <a
                        href="#servicios"
                        data-testid="nav-services"
                        className="hover:text-white transition-colors"
                    >
                        Servicios
                    </a>
                    <a
                        href="#contacto"
                        data-testid="nav-contact"
                        className="hover:text-white transition-colors"
                    >
                        Contacto
                    </a>
                </nav>

                <div className="flex items-center gap-2">
                    <a
                        href={AGENCY.emailUrl}
                        data-testid="header-email-link"
                        className="hidden sm:inline-flex items-center gap-2 text-xs tracking-widest uppercase text-white/70 hover:text-white transition px-3 py-2"
                    >
                        <Mail className="w-4 h-4" /> Email
                    </a>
                    <a
                        href={AGENCY.whatsappUrl}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="header-whatsapp-link"
                        className="inline-flex items-center gap-2 bg-[#FF2A2A] text-white px-5 py-2.5 rounded-full text-xs tracking-widest uppercase font-semibold hover:bg-[#CC1E1E] transition-colors"
                    >
                        <MessageCircle className="w-4 h-4" />
                        WhatsApp
                    </a>
                </div>
            </div>
        </header>
    );
};
